import { ProductDataList } from "entities/ClearanceDTO";
import { DarkSkyFilterParameter } from "../types";

type FilterFn = (
  item: ProductDataList,
  filters: DarkSkyFilterParameter
) => boolean;

const _accessoriesFilterId = -1;

export default function useDarkSky() {
  const filterByProductSeries: FilterFn = (item, filters) => {
    return (
      !filters.productSeriesId ||
      (item.mapProdSeriesArr &&
        item.mapProdSeriesArr.includes(filters.productSeriesId))
    );
  };

  const filterByProductType: FilterFn = (item, filters) => {
    if (filters.productTypeId === _accessoriesFilterId) return true;

    return (
      !filters.productTypeId ||
      (item.mapProdTypeArr &&
        item.mapProdTypeArr.includes(filters.productTypeId))
    );
  };

  const filterBySearchText: FilterFn = (item, filters) => {
    if (!filters.searchText) return true;
    const searchTextLower = filters.searchText.toLowerCase();
    return (
      item.productName.toLowerCase().includes(searchTextLower) ||
      item.productNumber.toLowerCase().includes(searchTextLower)
    );
  };

  const FILTERS: FilterFn[] = [
    filterByProductSeries,
    filterByProductType,
    filterBySearchText,
  ];

  function applyFilters(
    items: ProductDataList[],
    filters: DarkSkyFilterParameter
  ) {
    return items.filter((item) => FILTERS.every((fn) => fn(item, filters)));
  }

  return {applyFilters};
}
